import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SpecialtiesModal } from "../../types/specialities/SpecialitiesModal";
import axios from "axios";
import axiosInstance from "../../axios/axiosInstance";

interface SpecialtiesState {
  specializeLoading: boolean;
  specializeSuccess: boolean;
  specializeError: any;
  specializes: SpecialtiesModal[];
}

const initialState: SpecialtiesState = {
  specializeLoading: false,
  specializeSuccess: false,
  specializeError: "",
  specializes: [],
};



const apiUrl = process.env.BASE_URL;
export const getSpecialize = createAsyncThunk<any>(
    "Specialize/getSpecialize",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.get(`${apiUrl}/specialities/fetchActive`);
        return response.data.data;
      } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
          return rejectWithValue(error.response.data);
        } else {
          return rejectWithValue(
            "An Unknown error occurred while getting specialize"
          );
        }
      }
    }
  );


  const specializeSlice = createSlice({
    name: "Specialize", //Slice Name
    initialState,
    reducers: {
        specializeClearSuccess: (state) => {
        state.specializeSuccess = false;
      },
    },


     extraReducers: (builder) => {
        builder
          .addCase(getSpecialize.pending, (state) => {
            state.specializeLoading = true;
            state.specializeSuccess = false;
            state.specializeError = null;
          })
          .addCase(getSpecialize.fulfilled, (state, action) => {
            state.specializeLoading = false;
            state.specializeSuccess = true;
            state.specializes = action.payload;
          })
          .addCase(getSpecialize.rejected, (state, action) => {
            state.specializeLoading = false;
            state.specializeError = action.payload;
          });
      },
})


export const { specializeClearSuccess } = specializeSlice.actions;
export default specializeSlice.reducer;
